<div class="page-actions">
  <dcu-action-bar [selectedRecords]="selectedRecords"
                    [actionBarConfig]="bodyContent.actionBars"
                    (refreshChange)="refreshAll($event)"
                    (deletingCompleted)="refreshAll($event)"
                    [screenName]="bodyContent.actionBars?.screenName"
                    [customModal]="customModal"
                    (confirm)="onConfirm()"
                    [isEditStatusDate]="isEditDateDeactivate"
                    (closeChange)="onCloseChange()"
                    [actionId]="bodyContent.actionBars.id ? bodyContent.actionBars.id : 'main-action-id'"
  >
  </dcu-action-bar>
</div>

<!-- Breadcrumb -->
<cui-breadcrumb></cui-breadcrumb>

<dcu-body-content
  #csBodyContent
  [bodyContent]="bodyContent"
  (onFilterStatus)="onChangeStatus($event)"
  (onChangeFilterBox)="onChangeDataFilter($event)"
  (onSearchBox)="onChangeSearchBox($event)"
  (selectedRow)="onChangeSelectedValue($event)"
  (onCustomRouting)="customRouting($event)"
  [refresh]="refresh"
  [id]="id"
  [showFilter]="showFilter"
  [isCustomStatus]="isCustomStatus"
  [statusList]="statusList"
>
  <div retrieve>
    <ng-content select="[retrieve]"></ng-content>
  </div>
</dcu-body-content>
